export const MIGRATION_STEPS = {
  ENABLE: 1,
  DNS: 2,
  ISSUANCE: 3
};

export const STEP_STATUS = {
  IDLE: 'idle',
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error'
};

export const POLLING_CONFIG = {
  INTERVAL_MS: 5000,
  MAX_ATTEMPTS: 5
};
